import {
  Box,
  Button,
  Chip,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import Utils from "../../../utils";

const TableList = ({
  empresas,
  page,
  totalCount,
  rowsPerPage,
  handleEditEmpresa,
  handleChangePage,
  handleRowsPerPage,
  isLoading = false,
}) => {
  const renderSkeletonRow = (_, index) => (
    <TableRow key={`skeleton-${index}`}>
      <TableCell align="left">
        <Skeleton width="40%" height={24} />
        <Skeleton width="80%" height={16} />
        <Skeleton width="80%" height={14} />
      </TableCell>
      <TableCell>
        <Skeleton width="80%" height={24} />
      </TableCell>
      <TableCell align="right">
        <Skeleton width="80%" height={36} />
      </TableCell>
    </TableRow>
  );

  const renderDataRow = (empresa) => (
    <TableRow key={empresa.id}>
      <TableCell align="left">
        <Typography variant="h6">{empresa.nome}</Typography>

        <Typography variant="caption">{empresa.razaoSocial}</Typography>

        <Typography style={{ color: "lightGray" }}>
          {`ID #${empresa.id} 
                ${
                  empresa.idExterno ? " | ID externo #" + empresa.idExterno : ""
                }
                ${empresa.cpfCnpj ? " | CNPJ: " + empresa.cpfCnpj : ""}
                | Cadastro: ${empresa.createdAt}
                ${empresa.tipoConta ? "| Conta: " + empresa.tipoConta : ""}`}
        </Typography>
      </TableCell>

      <TableCell>{Utils.formatarDataHora(empresa.dataBloqueio)}</TableCell>

      <TableCell align="right">
        {!empresa.ativo && <Chip label="Inativo" />}
        <Button
          startIcon={<EditIcon />}
          color="primary"
          onClick={() => handleEditEmpresa(empresa)}
          variant="text"
          size="medium"
        >
          Editar
        </Button>
      </TableCell>
    </TableRow>
  );

  return (
    <Box p={3}>
      <TableContainer>
        <Table size="small">
          <TableBody>
            {isLoading
              ? Array.from({ length: rowsPerPage }).map(renderSkeletonRow)
              : empresas.map(renderDataRow)}
          </TableBody>
        </Table>

        <TablePagination
          rowsPerPageOptions={[10, 20, 30, 100]}
          component="div"
          count={totalCount}
          rowsPerPage={rowsPerPage}
          labelRowsPerPage="Linhas por página"
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleRowsPerPage}
        />
      </TableContainer>
    </Box>
  );
};

export default TableList;
